import React, { useEffect, useState, useRef } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import Down from "../../../src/Images/down.png";
import "./attendance-record-details.css";
import NotFoundData from "../../Images/no-data-found.webp";

const AttendanceRecordDetails = ({
  match,
  history,
  getDaysData,
  getAllTheDaysData = [],
  meetingDataForADate,
  getAttendanceData = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [expandedRecordIndex, setExpandedRecordIndex] = useState(null);
  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const now = new Date();
  const options = { year: "numeric", month: "long" };

  const [expanded, setExpanded] = useState(false);
  const dropdownRef = useRef(null);

  const decodeData = match?.params?.key;

  const decodedString = atob(decodeData);
  const decodedData = decodedString.split("|"); 

  const dateFormatted = decodedData[0] ?? 'N/A';
  const dateNumber = decodedData[1] ?? 'N/A';
  const monthName = decodedData[2] ?? 'N/A';
  const dayName = decodedData[3] ?? 'N/A';
  const decodedStatus = decodedData[4] ?? 'N/A';
  const checkInTime = decodedData[5] ?? 'N/A';
  const checkOutTime = decodedData[6] ?? 'N/A';

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getDaysData(currentMonth, currentYear);
      await meetingDataForADate(dateFormatted);
      setIsLoading(false);
    })();
  }, [getDaysData]);

  const toggleExpand = (index) => {
    setExpandedRecordIndex(expandedRecordIndex === index ? null : index);
  };

  useEffect(() => {
    if (expanded && dropdownRef.current) {
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const isOverflowing = dropdownRect.right > window.innerWidth;

      if (isOverflowing) {
        dropdownRef.current.style.right = "auto";
        dropdownRef.current.style.left = "auto";
        dropdownRef.current.style.transform = "translateX(-80%)";
      } else {
        dropdownRef.current.style.right = "0";
        dropdownRef.current.style.transform = "none";
      }
    }
  }, [expanded]);

  const getStatusClassName = (status) => {
    switch (status) {
      case "Present":
        return "status present";
      case "Absent":
        return "status absent";
      case "Weekly Off":
        return "status weekly-off";
      case "Holiday":
        return "status holiday";
      default:
        return "status";
    }
  };

  const toggleExpandRemark = (index) => {
    setExpandedRecordIndex(expandedRecordIndex === index ? null : index);
  };
  

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={dateFormatted +" Details"} history={history} />
            <div className="container-fluid common-bg">
              {/* Heading */}
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="attendance-record">
                  <div className="attendance-item">
                    <div className="left-side">
                      <div className="date">
                        {dateNumber} {monthName}{" "}
                        <br></br>
                        {dayName}
                      </div>
                    </div>
                    <div className="right-side">
                      <div
                        className={getStatusClassName(decodedStatus)}
                      >
                        {decodedStatus}
                      </div>
                      <div className="time">
                        <p>
                          {checkInTime && checkOutTime
                                ? `${checkInTime} ➔ ${checkOutTime}`
                                : ""}
                        </p>
                      </div>
                      {/* <div className="shift">{"Shift"}</div> */}
                    </div>
                  </div>
                  {getAttendanceData &&
                    getAttendanceData.data &&
                    getAttendanceData.data.length > 0 &&
                    getAttendanceData.data.map((record, index) => (
                      <div key={index} className="attendance-item">
                        <div className="left-side">
                          <div className="date">{record?.Date}</div>
                        </div>
                        <div className="right-side">
                          <div className="shift">
                            {record?.module_type ? (
                            <b>
                              Activity-{index + 1} ({record?.module_type})
                            </b>
                            ) : (
                            <b>
                              Activity-{index + 1} ({'Regularization'})
                            </b>
                            )}
                          </div>
                        {record?.regularization_date ? (
                        <>
                          <div className="shift">
                            <b>Check-in time: </b> {record?.check_in_time  ?? 'N/A.'}
                          </div>
                          <div className="shift">
                            <b>Check-out time: </b> {record?.check_out_time ?? 'N/A.'}
                          </div>
                        </>
                        ) : (
                        <>
                          <div className="shift">
                            <b>Check-in time: </b> {record?.check_in_date}
                          </div>
                          <div className="shift">
                            <b>Check-out time: </b> {record?.check_out_date ?? 'N/A.'}
                          </div>
                        </>
                        )}
                        {record?.location_of_work && (
                          <div className="shift">
                            <b>Location Of Work: </b> {record?.location_of_work}
                          </div>
                        )}
                        {record?.regularization_date && (
                        <>
                          {record?.status == 0 && (
                            <div className="shift">
                              <b>Status: </b><span style={{'color': 'orange'}}>{'Pending'}</span>
                            </div>
                          )}
                          {record?.status == 1 && (
                            <div className="shift">
                              <b>Status: </b><span style={{'color': '#138017'}}>{'Approved'}</span>
                            </div>
                          )}
                          {record?.status == 2 && (
                          <>
                            <div className="shift">
                              <b>Status: </b><span style={{'color': 'red'}}>{'Rejected'}</span>
                            </div>
                            <div className="shift">
                              <b>Manager Remark: </b>
                              <span>
                                {expandedRecordIndex === index
                                  ? record?.manager_remark
                                  : `${record?.manager_remark.slice(0, 15)}${record?.manager_remark.length > 15 ? '...' : ''}`}
                                {record?.manager_remark.length > 15 && (
                                  <button
                                    onClick={() => toggleExpandRemark(index)}
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                      border: "none",
                                      background: "none",
                                      color: "blue",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {expandedRecordIndex === index ? "Show Less" : "Show More"}
                                  </button>
                                )}
                              </span>
                            </div>
                          </>
                          )}
                          </>
                        )}
                        
                        {record?.office_location && (
                          <div className="shift">
                            <b>Office Location: </b> {record?.office_location}
                          </div>
                        )}
                        {record?.module_type == "Out Of Office" && (
                          <>
                            {record?.regularization_status == 0 && (
                              <div className="shift">
                                <b>Status: </b><span style={{'color': 'orange'}}>{'Pending'}</span>
                              </div>
                            )}
                            {record?.regularization_status == 1 && (
                              <div className="shift">
                                <b>Status: </b><span style={{'color': '#138017'}}>{'Approved'}</span>
                              </div>
                            )}
                            {record?.regularization_status == 2 && (
                            <>
                              <div className="shift">
                                <b>Status: </b><span style={{'color': 'red'}}>{'Rejected'}</span>
                              </div>
                              <div className="shift">
                                <b>Manager Remark: </b>
                                <span>
                                  {expandedRecordIndex === index
                                    ? record?.regularization_approver_remark
                                    : `${record?.regularization_approver_remark.slice(0, 15)}${record?.regularization_approver_remark.length > 15 ? '...' : ''}`}
                                  {record?.regularization_approver_remark.length > 15 && (
                                    <button
                                      onClick={() => toggleExpandRemark(index)}
                                      style={{
                                        marginLeft: "5px",
                                        cursor: "pointer",
                                        border: "none",
                                        background: "none",
                                        color: "blue",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {expandedRecordIndex === index ? "Show Less" : "Show More"}
                                    </button>
                                  )}
                                </span>
                              </div>
                            </>
                            )}
                          </>
                        )}
                        </div>
                      </div>
                    ))}
                    {getAttendanceData && getAttendanceData?.data && getAttendanceData?.data.length == 0 && (
                      <div className="text-center">
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt={"not found"}
                        />
                        <br />
                        <div style={{ fontSize: "large", fontWeight: "400" }}>
                          No data found
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Section ends */}
    </>
  );
};

export default AttendanceRecordDetails;
